const LIGHT_BG_PATTERNS = [
  "ubsecondarybutton",
  "buttonteritary",
  "buttontertiary",
  "nonidealsecondarybutton",
  "nonidealtransparentbutton",
  "foundationgreylightbg",
  "qrbtnstyle",
  "copybtn",
  "actionsbutton",
  "whitebg",
  "bgwhite",
  "newfontcolor",
  "barclayblue",
  "downloadpdfbtn",
  "downloadreportbtn",
  "darkgraycolor",
];

const DARK_BG_PATTERNS = [
  "ubprimarybutton",
  "buttonprimary",
  "savesalebutton",
  "nonidealprimarybutton",
  "deleteinvoicemodal",
  "chargecta",
  "brightgreen",
  "bgprimary",
];

/**
 * Picks loaderCircle utility class from button className (light vs dark background).
 * Explicit spinnerColor prop always wins when provided.
 */
export function resolveSpinnerColor(className = "", explicitColor) {
  if (explicitColor != null && explicitColor !== "") {
    return explicitColor;
  }

  const c = String(className).toLowerCase();

  if (c.includes("spinner-maincolor") || (c.includes("maincolor") && c.includes("transparent"))) {
    return "mainColor";
  }
  if (c.includes("black")) {
    return "black";
  }
  if (LIGHT_BG_PATTERNS.some((pattern) => c.includes(pattern))) {
    return c.includes("nonidealtransparentbutton") ? "mainColor" : "newFontColor";
  }
  if (DARK_BG_PATTERNS.some((pattern) => c.includes(pattern))) {
    return "white";
  }

  return "white";
}
